import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import axios from 'axios';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from 'react-bootstrap/Breadcrumb';

import {
    Table
    , Pagination
    , Button
    , IconButton
    , ButtonToolbar
    , Tooltip
    , Whisper
    , MultiCascader
    , HStack
    , VStack
    , SelectPicker
    , Input
    , InputNumber
    , InputGroup
    , Text
    , Modal
    , Container
    , Toggle
    , Loader
} from 'rsuite';

import Swal from 'sweetalert2'

export default class ApplicantPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            authHeader: { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } },
            content: null,
            modal: null,
            loading: false,
            data: [],
            sortColumn: '',
            sortType: '',
            loading: false,
            limit: 15,
            page: 1,
            yearData: [],
            defaultYear: '',
            rightData: [
                { label: 'สิทธิ์ที่ 1', value: 'Rights1' }
                , { label: 'สิทธิ์ที่ 2', value: 'Rights2' }
                , { label: 'สิทธิ์ที่ 3', value: 'Rights3' }
                , { label: 'สิทธิ์ที่ 4', value: 'Rights4' }
            ],
            villageData: [],
            schoolData: [],
            statusData: [
                { label: 'สอบติดเรียบร้อยและยืนยันการเข้าเรียน', value: 'สอบติดเรียบร้อยและยืนยันการเข้าเรียน' }
                , { label: 'สอบติดเรียบร้อยแต่ยังไม่ได้ยืนยันการเข้าเรียน', value: 'สอบติดเรียบร้อยแต่ยังไม่ได้ยืนยันการเข้าเรียน' }
                , { label: 'รอผลประกาศการสอบเข้า', value: 'รอผลประกาศการสอบเข้า' }
                , { label: 'ยังไม่ได้ดำเนินการสอบ', value: 'ยังไม่ได้ดำเนินการสอบ' }
            ],
            villageApplicant: '',
            schoolApplicant: '',
            queryApplicant: '',
            decision_result: 0,
            cost_of_living: '',
            tuition_fee: '',
            dormitory: '',
            registration: ''
        };
    }

    async componentDidMount() {
        const response = await axios.get(`${process.env.REACT_APP_API}/status/1`, this.state.authHeader);
        await this.promisedSetState({ defaultYear: response.data[0]?.default_year })
        await this.onRenderContent({ mode: 'read' })
    }

    promisedSetState = (newState) => new Promise(resolve =>
        this.setState(newState, resolve)
    );

    fetchYearData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/years`, this.state.authHeader);
            const formattedData = response.data.map(year => ({
                value: year.year_name,
                label: year.year_name
            }));
            await this.promisedSetState({ yearData: formattedData });
        } catch (err) {
            console.log({ error: 'Failed to load fetchYearData data' });
        }
    };

    fetchVillageData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/villages`, this.state.authHeader);
            const formattedData = response.data.map(data => ({
                value: data.name,
                label: data.name
            }));
            await this.promisedSetState({ villageData: formattedData });
        } catch (err) {
            console.log({ error: 'Failed to load fetchVillageData data' });
        }
    };

    fetchSchoolData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/schools`, this.state.authHeader);
            const formattedData = response.data.map(data => ({
                value: data.name,
                label: data.name
            }));

            // Add "อื่นๆ" as the last option
            formattedData.push({
                label: 'อื่นๆ',  // Label for the "Others" option
                value: 'อื่นๆ'   // Value for the "Others" option
            });

            await this.promisedSetState({ schoolData: formattedData });
        } catch (err) {
            console.log({ error: 'Failed to load fetchSchoolData data' });
        }
    };

    calculateAge = (date_of_birth) => {
        const birthDate = new Date(date_of_birth);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const month = today.getMonth() - birthDate.getMonth();

        if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    }

    handleSortColumn = async (sortColumn, sortType) => {
        await this.promisedSetState({ loading: true });

        await new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, 500);
        });

        await this.promisedSetState({ loading: false });
        await this.promisedSetState({ sortColumn, sortType });

        // Call your onRenderContent function if needed
        await this.onRenderContent({ read: true });
    };

    getData = async () => {
        if (this.state.sortColumn && this.state.sortType) {
            return this.state.data.sort((a, b) => {
                let x = a[this.state.sortColumn];
                let y = b[this.state.sortColumn];
                if (typeof x === 'string') {
                    x = x.charCodeAt();
                }
                if (typeof y === 'string') {
                    y = y.charCodeAt();
                }
                if (this.state.sortType === 'asc') {
                    return x - y;
                } else {
                    return y - x;
                }
            });
        }

        return this.state.data.filter((v, i) => {
            const start = this.state.limit * (this.state.page - 1);
            const end = start + this.state.limit;
            return i >= start && i < end;
        });
    };

    formatBaht(income) {
        // Convert the number to a formatted string with commas and two decimal places
        return income.toLocaleString('th-TH', {
            minimumFractionDigits: 2,  // Ensures two decimal places
            maximumFractionDigits: 2   // Limits to two decimal places
        });
    }

    handleToggle = () => {
        this.setState(prevState => ({ isOpen: !prevState.isOpen }), () => {
            // เรียกใช้งาน callback หลัง toggle
            this.onRenderContent({ mode: 'read' });
        });
    };

    onRenderContent = async ({ mode }) => {
        if (mode === 'read') {
            try {

                const { Column, HeaderCell, Cell } = Table;

                await this.promisedSetState({ loading: true }); // Set loading state

                await this.fetchYearData()
                await this.fetchVillageData()
                await this.fetchSchoolData()

                const responseApplicant = await axios.post(`${process.env.REACT_APP_API}/approved/years`, {
                    year: this.state.defaultYear
                    , village: this.state.villageApplicant
                    , school: this.state.schoolApplicant
                    , query: this.state.queryApplicant
                }, this.state.authHeader);

                const data = await Promise.all(responseApplicant.data.map(async (data, index) => ({
                    index: index + 1,
                    id: data.id,
                    prefix: data.prefix,
                    name: `${data.first_name} ${data.last_name}`,
                    nickname: data.nickname,
                    age: this.calculateAge(data.date_of_birth),
                    village: data.reg_village === 'other' ? data.reg_village_name : data.reg_village,
                    school: data.next_institution,
                    budget: data.decision_result ? this.formatBaht(Number(data.cost_of_living) + Number(data.tuition_fee) + Number(data.dormitory) + Number(data.registration)) : this.formatBaht(0),
                    disbursement: this.formatBaht(0),
                    balance: data.decision_result ? this.formatBaht(Number(data.cost_of_living) + Number(data.tuition_fee) + Number(data.dormitory) + Number(data.registration)) : this.formatBaht(0),
                })));

                await this.promisedSetState({ data: data });

                const paginatedData = await this.getData();

                await this.promisedSetState({
                    content: <>
                        <Row className='mt-3'>
                            <Col>
                                <Breadcrumb size='lg' >
                                    <Breadcrumb.Item><Link to="/admin"><i className="bi bi-house-fill"></i></Link></Breadcrumb.Item>
                                    <Breadcrumb.Item active>นักเรียนที่ได้รับทุน</Breadcrumb.Item>
                                </Breadcrumb>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                {this.state.isOpen && (
                                    <Row className='mb-3'>
                                        <Col lg={3} className='mb-1'>
                                            <VStack>
                                                <label>หมู่บ้าน</label>
                                                <SelectPicker size='lg'
                                                    data={this.state.villageData}
                                                    placeholder='กรุณาเลือก'
                                                    style={{ width: '100%' }}
                                                    onSelect={async (v, i) => {
                                                        await this.promisedSetState({ villageApplicant: v })
                                                        await this.onRenderContent({ mode: 'read' })
                                                    }}
                                                    onClean={async () => {
                                                        await this.promisedSetState({ villageApplicant: '' })
                                                        await this.onRenderContent({ mode: 'read' })
                                                    }}
                                                />
                                            </VStack>
                                        </Col>
                                        <Col lg={4} className='mb-1'>
                                            <VStack>
                                                <label>สถานศึกษาเรียนต่อ</label>
                                                <SelectPicker size='lg'
                                                    data={this.state.schoolData}
                                                    placeholder='กรุณาเลือก'
                                                    style={{ width: '100%' }}
                                                    onSelect={async (v, i) => {
                                                        await this.promisedSetState({ schoolApplicant: v })
                                                        await this.onRenderContent({ mode: 'read' })
                                                    }}
                                                    onClean={async () => {
                                                        await this.promisedSetState({ schoolApplicant: '' })
                                                        await this.onRenderContent({ mode: 'read' })
                                                    }}
                                                />
                                            </VStack>
                                        </Col>
                                    </Row>
                                )}

                                <Row>
                                    <Col lg={2} className='mb-2'>
                                        <HStack>
                                            <label><b>ปีการศึกษา</b></label>
                                            <SelectPicker size='lg'
                                                data={this.state.yearData}
                                                searchable={false}
                                                cleanable={false}
                                                placeholder='กรุณาเลือก'
                                                defaultValue={this.state.defaultYear}
                                                style={{ width: '120px' }}
                                                onSelect={async (v, i) => {
                                                    await this.promisedSetState({ defaultYear: v })
                                                    this.onRenderContent({ mode: 'read' })
                                                }}
                                            />
                                        </HStack>
                                    </Col>
                                    <Col>
                                        <HStack>
                                            <InputGroup size='lg' style={{ width: 300 }}>
                                                <InputGroup.Addon>
                                                    <i className="bi bi-search"></i>
                                                </InputGroup.Addon>
                                                <Input
                                                    onChange={e => this.setState({ queryApplicant: e })}
                                                    onKeyDown={e => e.key === 'Enter' && this.onRenderContent({ mode: 'read' })}
                                                />
                                            </InputGroup>
                                            <Button appearance="primary">ค้นหา</Button>
                                        </HStack>
                                    </Col>
                                    <Col lg={4} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <Toggle
                                            size="md"
                                            checked={this.state.isOpen}
                                            onChange={this.handleToggle}
                                            style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '8px' }}
                                        >
                                            <Text muted>ตัวกรอง</Text>
                                        </Toggle>
                                    </Col>
                                </Row>
                                <Row className='mt-2'>
                                    <Col>
                                        <Table
                                            autoHeight
                                            data={paginatedData}
                                            bordered
                                            cellBordered
                                            sortColumn={this.state.sortColumn}
                                            sortType={this.state.sortType}
                                            onSortColumn={async (sortColumn, sortType) => {
                                                await this.handleSortColumn(sortColumn, sortType);
                                            }}
                                            className='shadow-sm'
                                        >
                                            <Column width={50} align="center">
                                                <HeaderCell>ลำดับ</HeaderCell>
                                                <Cell dataKey="index" />
                                            </Column>

                                            <Column width={80} resizable>
                                                <HeaderCell>คำนำหน้า</HeaderCell>
                                                <Cell dataKey="prefix" />
                                            </Column>

                                            <Column width={160} >
                                                <HeaderCell>ชื่อ-นามสกุล</HeaderCell>
                                                <Cell>
                                                    {rowData => (
                                                        <span dangerouslySetInnerHTML={{ __html: rowData.name }} />
                                                    )}
                                                </Cell>
                                            </Column>

                                            <Column width={90} resizable>
                                                <HeaderCell>ชื่อเล่น</HeaderCell>
                                                <Cell dataKey="nickname" />
                                            </Column>

                                            <Column width={70} resizable>
                                                <HeaderCell>อายุ</HeaderCell>
                                                <Cell dataKey="age" />
                                            </Column>

                                            <Column width={180} resizable>
                                                <HeaderCell>หมู่บ้าน</HeaderCell>
                                                <Cell dataKey="village" />
                                            </Column>

                                            <Column width={240} resizable>
                                                <HeaderCell>สถานศึกษาเรียนต่อ</HeaderCell>
                                                <Cell dataKey="school" />
                                            </Column>

                                            <Column width={125} resizable align='right'>
                                                <HeaderCell>เงินสนับสนุน</HeaderCell>
                                                <Cell dataKey="budget" />
                                            </Column>

                                            <Column width={125} resizable align='right'>
                                                <HeaderCell>เบิกจ่าย</HeaderCell>
                                                <Cell dataKey="disbursement" />
                                            </Column>

                                            <Column width={125} resizable align='right'>
                                                <HeaderCell>คงเหลือ</HeaderCell>
                                                <Cell dataKey="balance" />
                                            </Column>

                                            <Column width={50} fixed="right" align='center'>
                                                <HeaderCell>...</HeaderCell>

                                                <Cell style={{ padding: '6px' }}>
                                                    {rowData => (
                                                        <ButtonToolbar>
                                                            <Whisper followCursor speaker={<Tooltip>ดูรายละเอียด</Tooltip>}>
                                                                <Link to={`/admin/applicant/detail/${rowData.id}`}>
                                                                    <IconButton
                                                                        size='sm'
                                                                        color="blue"
                                                                        appearance="primary"
                                                                        icon={<i className="bi bi-file-earmark-text"></i>}
                                                                    />
                                                                </Link>
                                                            </Whisper>
                                                        </ButtonToolbar>
                                                    )}
                                                </Cell>
                                            </Column>
                                        </Table>

                                        <div style={{ padding: 20 }}>
                                            <Pagination
                                                prev
                                                next
                                                first
                                                last
                                                ellipsis
                                                boundaryLinks
                                                maxButtons={5}
                                                size="xs"
                                                layout={['total', '|', 'pager']}
                                                total={data.length}
                                                limit={this.state.limit}
                                                activePage={this.state.page}
                                                onChangePage={async (e) => {
                                                    await this.promisedSetState({ page: e }); // Update current page
                                                    await this.onRenderContent({ mode: 'read' }); // Fetch new data based on page
                                                }}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <br />
                    </>
                })

                await this.promisedSetState({ loading: false })

            } catch {
                // Redirect to Log In
                window.location.href = '/admin/login';
            }
        }
    }

    onModal = async ({ mode, id }) => {
        if (mode === 'consider') {
            const response = await axios.get(`${process.env.REACT_APP_API}/application/${id}`, this.state.authHeader);
            const data = response.data[0]

            await this.promisedSetState({
                decision_result: data.decision_result,
                cost_of_living: data.cost_of_living,
                tuition_fee: data.tuition_fee,
                dormitory: data.dormitory,
                registration: data.registration
            })

            await this.promisedSetState({
                modal: <Modal backdrop={'static'}
                    keyboard={false}
                    open={true}
                    onClose={() => this.setState({ modal: null })}
                >
                    <Modal.Header>
                        <Modal.Title>การคัดเลือกรับทุนการศึกษา</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Container>
                            <HStack>
                                <label>ชื่อ-นามสกุล: </label>
                                <Text>{`${data.first_name} ${data.last_name}`}</Text>
                            </HStack>
                            <HStack>
                                <label>ชื่อเล่น: </label>
                                <Text>{'ทดสอบ'}</Text>
                            </HStack>
                            <HStack>
                                <label>ที่อยู่: </label>
                                <Text>{data.reg_province_id === 1 ?
                                    `${data.reg_house_number} หมู่ ${data.reg_village_no} หมู่บ้าน${data.reg_village === 'other' ? data.reg_village_name : data.reg_village} ${data.reg_tambon} ${data.reg_amphur} ${data.reg_province}`
                                    : `${data.reg_house_number} หมู่ ${data.reg_village_no} หมู่บ้าน${data.reg_village === 'other' ? data.reg_village_name : data.reg_village} ต.${data.reg_tambon} อ.${data.reg_amphur} จ.${data.reg_province}`}</Text>
                            </HStack>
                            <HStack>
                                <label>สถานศึกษาที่จะเรียนต่อ: </label>
                                <Text>{data.next_institution}</Text>
                            </HStack>
                            <hr />
                            <HStack>
                                <label><b>สถานะการคัดเลือก: </b></label>
                                <Toggle
                                    checkedChildren="ผ่าน"
                                    unCheckedChildren="ไม่ผ่าน"
                                    defaultChecked={this.state.decision_result}
                                    onChange={e => this.setState({ decision_result: e })}
                                />
                            </HStack>
                            <label className='mt-3 mb-2'><b>งบประมาณที่สนับสนุน</b></label>
                            <VStack className='mb-2'>
                                <label>ค่าครองชีพ</label>
                                <InputNumber
                                    className=''
                                    size='lg'
                                    defaultValue={this.state.cost_of_living}
                                    min={0}
                                    formatter={this.to2decimal}
                                    style={{ width: '100%' }}
                                    onChange={e => this.setState({ cost_of_living: e })}
                                />
                            </VStack>
                            <VStack className='mb-2'>
                                <label>ค่าหลักสูตร</label>
                                <InputNumber
                                    size='lg'
                                    defaultValue={this.state.tuition_fee}
                                    min={0}
                                    formatter={this.to2decimal}
                                    style={{ width: '100%' }}
                                    onChange={e => this.setState({ tuition_fee: e })}
                                />
                            </VStack>
                            <VStack className='mb-2'>
                                <label>ค่าหอพัก</label>
                                <InputNumber
                                    size='lg'
                                    defaultValue={this.state.dormitory}
                                    min={0}
                                    formatter={this.to2decimal}
                                    style={{ width: '100%' }}
                                    onChange={e => this.setState({ dormitory: e })}
                                />
                            </VStack>
                            <VStack>
                                <label>ค่าธรรมเนียมแรกเข้า</label>
                                <InputNumber
                                    size='lg'
                                    defaultValue={this.state.registration}
                                    min={0}
                                    formatter={this.to2decimal}
                                    style={{ width: '100%' }}
                                    onChange={e => this.setState({ registration: e })}
                                />
                            </VStack>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size='sm'
                            startIcon={<i className="bi bi-floppy"></i>}
                            appearance="primary"
                            onClick={() => this.onConfirm({ mode, id })}
                        >
                            บันทึก
                        </Button>
                        <Button size='sm'
                            appearance="subtle"
                            onClick={() => this.setState({ modal: null })}
                        >
                            ยกเลิก
                        </Button>
                    </Modal.Footer>
                </Modal>
            });
        }
    }

    to2decimal = (value) => {
        return `${(value * 1).toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}`
    }

    toInterger = (value) => {
        return `${(value * 1).toFixed(0).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}`
    }

    onConfirm = async ({ mode, id }) => {
        if (mode === 'consider') {
            const Response = await axios.put(`${process.env.REACT_APP_API}/decistion`, {
                id: id
                , decision_result: this.state.decision_result
                , cost_of_living: this.state.cost_of_living
                , tuition_fee: this.state.tuition_fee
                , dormitory: this.state.dormitory
                , registration: this.state.registration
            }, this.state.authHeader);

            const data = Response.data;

            if (data.message === 'successfully') {

                await this.onRenderContent({ mode: 'read' })

                await this.promisedSetState({ modal: null })

                Swal.fire({
                    title: "คุณแก้ไขข้อมูลเรียบร้อยแล้ว",
                    icon: "success",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });
            }
        }
    }

    render() {

        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.content}
                {this.state.modal}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}
